export const FilterCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className={`flex flex-col sm:gap-1 ${ cardWidth } text-sm`}>
            <div className="min-h-5">
                <span>{ title === '' ? ' ' : title }</span>
            </div>
            <div className="flex items-end">
                { children }
            </div>
        </div>
    )
}